// 事业部相关的

import Layout from '@/layout';
var divisionRouter = {
  path: '/division',
  component: Layout,
  redirect: '/division/index',
  name: 'Division',
  meta: {
    title: '事业部',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/division/list/index');
    },
    name: 'divisionIndex',
    meta: {
      auth: ['agent-division-index'],
      title: '事业部列表',
      icon: ''
    }
  }, {
    path: 'agent/index',
    component: function component() {
      return import('@/views/division/agent/index');
    },
    name: 'agentIndex',
    meta: {
      auth: ['agent-division-agent-index'],
      title: '代理商列表',
      icon: ''
    }
  }, {
    path: 'agent/applyList',
    component: function component() {
      return import('@/views/division/agent/applyList');
    },
    name: 'agentApply',
    meta: {
      auth: ['agent-division-agent-applyList'],
      title: '代理商申请',
      icon: ''
    }
  }, {
    path: 'agent/agreement',
    component: function component() {
      return import('@/views/division/agent/agreement');
    },
    name: 'agentAgreement',
    meta: {
      auth: ['agent-division-agent-agreement'],
      title: '代理商协议',
      icon: ''
    }
  }]
};
export default divisionRouter;